// REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

// LOGIN
export const POST_FAKE_LOGIN = "/auth/signin";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

// PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Customers
export const GET_CUSTOMER_LIST = "/customers";
export const ADD_CUSTOMER_LIST = "/customers";
export const UPDATE_CUSTOMER_LIST = "/customers";
export const DELETE_CUSTOMER_LIST = "/customers/";

// TypeCustomers
export const GET_TYPECUSTOMER_LIST = "/typeCustomers";

// Addresses
export const GET_ADDRESS_LIST = "/addresses";
export const ADD_ADDRESS_LIST = "/addresses";
export const GET_ADDRESSES_BY_CUSTOMER_ID = (customerId: number | string) => `/addresses/${customerId}/customer`;

// Type Address
export const GET_TYPEADDRESS_LIST = "/typeAddresses";

// Telefonos
export const GET_PHONENUMBER_LIST = "/phoneNumbers";

// Countries, Departments, Municipalities
export const GET_COUNTRIES = "/countries";
export const GET_DEPARTMENTS_BY_COUNTRY = "/departments/search/findAllByCountry_CountryId";
export const GET_MUNICIPALITIES_BY_DEPARTMENT = "/municipalities/search/findAllByDepartment_DepartmentId";


// Wallets
export const GET_WALLET_LIST = "/wallets";
export const ADD_WALLET = "/wallets";
export const UPDATE_WALLET = "/wallets/";
export const DELETE_WALLET = "/wallets/";
export const GET_WALLET_NOT_VIRTUAL = "/wallets/search/findAllByIsVirtualWallet";

// Transfers
export const GET_TRANSACTIONS_LIST = "/transactions";

// Expenses Categories
export const GET_EXPENSE_CATEGORY_LIST = "/movementCategories";
export const ADD_EXPENSE_CATEGORY = "/movementCategories";
export const UPDATE_EXPENSE_CATEGORY = "/movementCategories/";
export const DELETE_EXPENSE_CATEGORY = "/movementCategories/";

// Expenses
export const GET_EXPENSE_LIST = "/movements";
export const ADD_EXPENSE = "/movements";
export const UPDATE_EXPENSE = "/movements/";
export const DELETE_EXPENSE = "/movements/";

// Loans
export const GET_LOAN_LIST = "/loans";
export const GET_LOAN = "/loans/";
export const GET_LOAN_STATEMENT = "/statements/loans/pdf/";

// Loan Payments
export const GET_LOAN_PAYMENT_LIST = "/summary/loan-payments";
export const GET_LOAN_PAYMENTDATE_LIST = "/loanPayments/search/getAllByLoanPaymentState_CodeAndPaymentDateBetween";
export const GET_LOAN_PAYMENT_BY_CODE_AND_LOANID = "loanPayments/search/getAllByLoanPaymentState_CodeInAndLoan_LoanId"
export const ADD_LOAN_PAYMENT = "/transfers/loan-payments";
export const UPDATE_LOAN_PAYMENT = "/loanPayments/";
export const DELETE_LOAN_PAYMENT = "/loanPayments/";
export const GET_REPORT_LOAN_PAYMENT_XLS = "/reports/loan-payments";
export const GET_REPORT_LOANS_GENERAL_XLS = "/reports/loans/general";
export const GET_REPORT_LOAN_PAYMENT_DATE_XLS = "/reports/loan-payments/by-payment-date";
export const GET_REPORT_EXPENSES_INCOMES_DATE_XLS = "/incomes-and-expenses/excel";
export const GET_REPORT_LOAN_PAYMENT_PDF = "/proof-payments/download/loan-receipt/";

// Loan Application
export const GET_LOAN_APPLICATION_LIST = "/loanApplications";
export const ADD_LOAN_APPLICATION = "/loanApplications";
export const UPDATE_LOAN_APPLICATION = "/loanApplications/";

// Loan Payment Status
export const GET_LOAN_PAYMENT_STATUS_LIST = "/loanPaymentStatus";

// Credit Destination
export const GET_CREDIT_DESTINATION_LIST = "/creditDestinations";
export const ADD_CREDIT_DESTINATION = "/creditDestinations";
export const UPDATE_CREDIT_DESTINATION = "/creditDestinations/";
export const DELETE_CREDIT_DESTINATION = "/creditDestinations/";

// Type Loan
export const GET_TYPE_LOAN_LIST = "/typeLoans";
export const ADD_TYPE_LOAN = "/typeLoans";
export const UPDATE_TYPE_LOAN = "/typeLoans/";
export const DELETE_TYPE_LOAN = "/typeLoans/";

// Warranty
export const GET_WARRANTY_LIST = "/warranties";
export const ADD_WARRANTY = "/warranties";
export const UPDATE_WARRANTY = "/warranties/";
export const DELETE_WARRANTY = "/warranties/";
export const GET_WARRANTY_BY_LOAN_APPLICATION_ID = "/warranties/search/findByLoanApplication_LoanApplicationId";

// Warranty Documents
export const UPLOAD_WARRANTY_FILE = "/files/warranty/";
export const GET_WARRANTY_DOCUMENTS = "/warrantyDocuments";
export const ADD_WARRANTY_DOCUMENT = "/warrantyDocuments";
export const UPDATE_WARRANTY_DOCUMENT = "/warrantyDocuments/";
export const DELETE_WARRANTY_DOCUMENT = "/warrantyDocuments/";
export const GET_WARRANTY_DOCUMENT_BI_FILENAME = "/files/download/";
export const GET_WARRANTY_DOCUMENT_BY_WARRANTY_ID = "/warrantyDocuments/search/findAllByWarranty_WarrantyId";

// Warranty Types
export const GET_WARRANTY_TYPE_LIST = "/warrantyTypes";
export const ADD_WARRANTY_TYPE = "/warrantyTypes";
export const UPDATE_WARRANTY_TYPE = "/warrantyTypes/";
export const DELETE_WARRANTY_TYPE = "/warrantyTypes/";

// Economic Activities Type
export const GET_ECONOMIC_ACTIVITIES_TYPE_LIST = "/economicActivityTypes";
export const ADD_ECONOMIC_ACTIVITIES_TYPE = "/economicActivityTypes";
export const UPDATE_ECONOMIC_ACTIVITIES_TYPE = "/economicActivityTypes/";
export const DELETE_ECONOMIC_ACTIVITIES_TYPE = "/economicActivityTypes/";

// Loan Application Status
export const GET_LOAN_APPLICATION_STATUS_LIST = "/loanApplicationStatus";

// Amortization Types
export const GET_AMORTIZATION_TYPE_LIST = "/amortizationTypes";

// Patronial State
export const GET_PATRIMONIAL_STATE_LIST = "/patrimonialStatus";
export const ADD_PATRIMONIAL_STATE = "/patrimonialStatus";
export const UPDATE_PATRIMONIAL_STATE = "/patrimonialStatus/";
export const DELETE_PATRIMONIAL_STATE = "/patrimonialStatus/";
export const GET_PATRIMONIAL_STATE = "/patrimonialStatus/";
export const GET_PATRIMONIAL_STATE_BY_LOAN_APPLICATION_ID = "/patrimonialStatus/search/getByLoanApplication_LoanApplicationId";


// Assets
export const GET_ASSET_LIST = "/assets";
export const ADD_ASSET = "/assets";
export const UPDATE_ASSET = "/assets/";
export const DELETE_ASSET = "/assets/";
export const GET_ASSET_BY_PATRIMONIAL_STATE = "/assets/search/getAllByPatrimonialStatus_PatrimonialStateId";

// Liabilities
export const GET_LIABILITY_LIST = "/liabilities";
export const ADD_LIABILITY = "/liabilities";
export const UPDATE_LIABILITY = "/liabilities/";
export const DELETE_LIABILITY = "/liabilities/";
export const GET_LIABILITY_BY_PATRIMONIAL_STATE = "/liabilities/search/getAllByPatrimonialStatus_PatrimonialStateId";


// Patrimonial Personal References
export const GET_PATRIMONIAL_PERSONAL_REFERENCES_LIST = "/patrimonialPersonalReferences";
export const ADD_PATRIMONIAL_PERSONAL_REFERENCES = "/patrimonialPersonalReferences";
export const UPDATE_PATRIMONIAL_PERSONAL_REFERENCES = "/patrimonialPersonalReferences/";
export const DELETE_PATRIMONIAL_PERSONAL_REFERENCES = "/patrimonialPersonalReferences/";
export const GET_PATRIMONIAL_PERSONAL_REFERENCES_BY_STATE = "/patrimonialPersonalReferences/search/getAllByPatrimonialStatus_PatrimonialStateId";

// Transfers
export const GET_TRANSFER_LIST = "/transfers";
export const ADD_TRANSFER = "/transfers/wallets";
